import { render, staticRenderFns } from "./AINurserySummary.vue?vue&type=template&id=20e2d768&scoped=true"
import script from "./AINurserySummary.vue?vue&type=script&lang=js"
export * from "./AINurserySummary.vue?vue&type=script&lang=js"
import style0 from "./AINurserySummary.vue?vue&type=style&index=0&id=20e2d768&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e2d768",
  null
  
)

export default component.exports